import { useFormState } from 'utils/hooks';
import { Button } from 'reactstrap';

import { FormBody } from 'common/components/drawer';
import { FormFooter } from 'common/components/drawer';

const UserForm = ({
  formState,
  collectValues,
  drawer,
  isDirty,
  hasErrors,
  submitForm,
  isSubmitting
}) => {
  const { fields, changeField, selectField } = useFormState(formState);

  const handleSubmitForm = async () => {
    const values = collectValues();
    if (!values) return;

    const params = {
      ...values
    };

    submitForm(params);
  };

  return (
    <>
      <FormBody isDirty={isDirty}>
        <div className="pt-3">User Form</div>
      </FormBody>

      <FormFooter>
        <Button color="cancel" className="px-0 py-1 me-4" onClick={drawer.close}>
          CANCEL
        </Button>
        <Button
          onClick={handleSubmitForm}
          disabled={isSubmitting || hasErrors}
          color="primary"
          className="px-4"
        >
          SAVE
        </Button>
      </FormFooter>
    </>
  );
};

export default UserForm;
